(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["withdrawal-form"] && !Shopify.designMode) return;
  try {
    const syncWithdrawalItemsRequired = (form) => {
    const partial = form.querySelector('input[name="contact[Alcance]"][data-withdrawal-partial]');
    const items = form.elements.namedItem('contact[Articulos]');
    if (partial && items instanceof HTMLTextAreaElement) {
      items.required = partial.checked;
    }
  };

  document.addEventListener('change', (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.name !== 'contact[Alcance]') return;

    const form = radio.closest('.withdrawal-form__form');
    if (form) syncWithdrawalItemsRequired(form);
  });

  // Browsers can restore the selected radio (reload, back/forward cache) without firing change.
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.withdrawal-form__form').forEach(syncWithdrawalItemsRequired);
  });
  } catch(e) { console.error(e); }
})();

})();
